export const GET_INCIDENT_IMAGES_REQUEST = "GET_INCIDENT_IMAGES_REQUEST";
export const GET_INCIDENT_IMAGES_SUCCESS = "GET_INCIDENT_IMAGES_SUCCESS";
export const GET_INCIDENT_IMAGES_FAIL = "GET_INCIDENT_IMAGES_FAIL";